import * as React from "react"

export type DevicesStreamHandler = (event: string, data: unknown) => void

export function useDevicesStream(handler: DevicesStreamHandler) {
  const ref = React.useRef(handler)
  ref.current = handler

  React.useEffect(() => {
    const es = new EventSource("/api/devices-stream")
    const make = (name: string) => (ev: MessageEvent) => {
      try { ref.current(name, JSON.parse(ev.data)) } catch { /* ignore */ }
    }
    const types = [
      "device:connected",
      "device:disconnected",
      "device:hello",
      "device:status",
      "device:log",
      "device:event",
      "device:frame",
    ]
    const listeners = types.map((t) => {
      const fn = make(t)
      es.addEventListener(t, fn as EventListener)
      return [t, fn] as const
    })
    return () => {
      for (const [t, fn] of listeners) {
        es.removeEventListener(t, fn as EventListener)
      }
      es.close()
    }
  }, [])
}
